<template>
  <div class='event-base'>
    <header-base />
    <h1>{{eventName}}</h1>
    <v-tabs
      background-color='deep-purple accent-4'
      color='white'
      grow
      v-model='currTab'
    >
      <v-tab key='qual'>Qualifiers</v-tab>
      <v-tab key='bracket'>Bracket</v-tab>

      <v-tabs-items touchless v-model='currTab'>
        <v-tab-item key='qual'>
          <results-table
            v-if='rounds.length > 0'
            :roundID="rounds[0].roundID"
            :roundType='type'
            :roundSolvers='rounds[0].solveTimes'
            :roundStatus="rounds[0].status"
            :eventSize="rounds.length > 1 ? parseInt(rounds[1].roundID.split('R')[1]) : 0"
            @refresh='refreshTab(true)'
          />
        </v-tab-item>
        <v-tab-item key='bracket'>
          <event-bracket :rounds='bracketRounds' @refresh='refreshTab(true)' />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import RoundsService from '@/services/TPC/RoundsService'

import HeaderBase from '@/components/TPC/Header/Base'
import ResultsTable from '@/components/TPC/Shared/ResultsTable'
import EventBracket from '@/components/TPC/Event/Bracket'

export default {
  name: 'event-base',
  components: {
    HeaderBase,
    ResultsTable,
    EventBracket
  },
  data () {
    return {
      eventName: 'Event',
      type: '3x3',
      status: 'OPEN',
      rounds: [],

      currTab: 0,
      loaded: {},
      loading: true, // prevent currTab from activating until finished loading rounds
    }
  },
  methods: {
    loadRound (i, force) {
      // the force option forces the round to be reloaded even if it has already been loaded
      if (this.loaded[i] && !force) return
      this.loaded[i] = true
      RoundsService.listResults('round', {roundID: this.rounds[i].roundID}).then(({data: results}) => {
        if (results.error) {
          console.error(`Error: ${results.error} - ${results.message}`)
          this.$set(this.rounds[i], 'solveTimes', {})
          return
        }
        this.$set(this.rounds[i], 'solveTimes', results.solveTimes)
      })
    },
    refreshTab (force) {
      if (this.loading) return
      if (this.currTab === 0) {
        this.loadRound(0, force)
      } else if (this.currTab === 1) {
        for (let i = 1; i < this.rounds.length; i++) {
          this.loadRound(i, force)
        }
      }
    }
  },
  watch: {
    roundLoader () {
      this.refreshTab(false)
    }
  },
  computed: {
    bracketRounds () {
      return this.rounds.length > 0 ? this.rounds.slice(1) : []
    },
    roundLoader () {
      return String(this.currTab) + String(this.loading)
    },
  },
  async created () {
    const {data: eventInfo} = await RoundsService.getEventInfo({eventID: this.$route.params.eid})
    if (eventInfo.error) {
      alert(`Try again. Error: ${eventInfo.error} - ${eventInfo.message}`)
      return
    }
    this.eventName = eventInfo.eventName
    this.$store.commit('setEventName', this.eventName)
    this.type = eventInfo.type
    this.status = eventInfo.status
    this.rounds = eventInfo.rounds

    // order rounds in order of progression (ie, Rqual => R64 => R32 => .... R4 => R2)
    this.rounds.sort((a, b) => {
      const rA = a.roundID.split('R')[1]
      const rB = b.roundID.split('R')[1]
      if (rA === 'qual') return -1
      if (rB === 'qual') return 1
      return parseInt(rB) - parseInt(rA)
    })

    this.currTab = (this.rounds[0].roundID.endsWith('qual') && (this.rounds[0].status !== 'OPEN' && this.rounds[0].status !== 'UPCOMING')) ? 1 : 0
    this.loading = false
  }
}
</script>

<style scoped>
.v-tab {
  color: white !important;
}
</style>
